import React from 'react';
import './Wardrobes.css';
import GalleryTemplate from "../gallery template/GalleryTemplate";

class Wardrobes extends React.Component {

    componentDidMount() {
    }

    render() {
        return (
            <div className={'page'}>
                <div className={'wardrobes'}>
                    <h1 className={'pageTitle'}>Custom Fitted Wardrobes & Bedroom Storage</h1>
                    <p className={'pageDescription'}>Transform your bedroom into a haven of organisation and style with our bespoke fitted wardrobes. Designed to your exact specifications, our custom solutions offer unparalleled storage capacity and a seamless, integrated look, ensuring every item has its place while complementing your room's design perfectly.</p>
                    <GalleryTemplate
                        title={'Modern High-Gloss Grey Fitted Wardrobes with Accent Lighting'}
                        description={'Achieve a contemporary look with these sleek, custom-fitted high-gloss grey wardrobes, offering generous storage and featuring optional integrated blue LED accent lighting for a striking modern aesthetic.'}
                        width={[4]}
                        height={[3]}
                        images={[
                            '/gallery/Wardrobes/2/20200615_125510_1.jpg',
                            '/gallery/Wardrobes/2/20200624_221252_1.jpg'

                        ]}/>
                    <GalleryTemplate
                        title={'Bespoke Corner Wardrobe and Media Unit'}
                        description={'This elegant, custom-fitted bedroom solution features a seamless corner wardrobe design with ample storage, integrated drawers, and a built-in media unit, all in a stylish cream finish.'}
                        width={[4]}
                        height={[3]}
                        images={[
                            '/gallery/Wardrobes/1/20200615_125324_1.jpg'
                        ]}/>
                    <GalleryTemplate
                        title={'Bespoke Shaker Style Wardrobe'}
                        description={'This elegant, custom-built wardrobe features classic shaker-style doors in a deep, sophisticated blue, offering ample storage and a timeless addition to any bedroom.'}
                        width={[4]}
                        height={[3]}
                        images={[
                            '/gallery/Bookcases/6/IMG-20250520-WA00031.JPG',
                            '/gallery/Bookcases/6/IMG-20250520-WA00041.JPG'
                        ]}/>
                </div>
            </div>
        );
    }
}

export default Wardrobes;
